<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      @click.self="emit('close')"
    >
      <div
        class="relative w-full max-w-md rounded-[20px] border border-tertiary bg-secondary p-8 shadow-2xl"
      >
        <h2 class="mb-6 border-b border-tertiary pb-4 text-xl font-bold text-text-main">
          Sichtbarkeit ändern
        </h2>
        <div class="mb-6">
          <label class="block text-sm font-bold text-text-main mb-2">
            Sichtbarkeit für Projekt <strong>{{ projectName }}</strong>:
          </label>
          <select
            v-model="selected"
            class="w-full rounded-standard border border-tertiary bg-primary px-3 py-2 text-sm text-text-main outline-none focus:border-accent"
          >
            <option value="private">
              Privat — nur du
            </option>
            <option value="internal">
              Intern — angemeldete Nutzer
            </option>
            <option value="public">
              Öffentlich — alle
            </option>
          </select>
          <p class="mt-2 text-xs text-text-main/60">
            Die Sichtbarkeit gilt für das gesamte Projekt (Dateiberechtigungen werden noch
            nicht einzeln unterstützt).
          </p>
        </div>

        <div class="flex items-center justify-end gap-3">
          <button
            type="button"
            class="cursor-pointer rounded-standard bg-accent px-6 py-2 text-sm font-semibold text-text-main shadow-sm transition-all duration-150 hover:brightness-110"
            @click="submit"
          >
            Speichern
          </button>
          <button
            type="button"
            class="cursor-pointer rounded-standard border border-tertiary bg-primary px-6 py-2 text-sm font-semibold text-text-main transition-colors duration-150 hover:bg-primary/80"
            @click="emit('close')"
          >
            Abbrechen
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

type Visibility = 'private' | 'internal' | 'public'

const props = defineProps<{
  isOpen: boolean
  projectName: string
  currentVisibility: Visibility
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (event: 'save', visibility: Visibility): void
}>()

const selected = ref<Visibility>('private')

watch(
  () => props.isOpen,
  (open) => {
    if (open) selected.value = props.currentVisibility
  }
)

function submit() {
  if (selected.value !== props.currentVisibility) {
    emit('save', selected.value)
  }
  emit('close')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
